import { GuidelineComponentLocalChanges, GuidelineChapterLocalChanges } from '@treetop/shared/model';

export const normalizeString = (value?: string | null): string => {
  return value?.trim() ?? '';
};

export type LocalChanges = GuidelineComponentLocalChanges | GuidelineChapterLocalChanges;

export const hasLocalChanges = (local: LocalChanges, original: LocalChanges): boolean => {
  if (!local) {
    return false;
  }

  const hasDescriptionChange = local.description != null && normalizeString(local.description) !== normalizeString(original.description);

  const hasDescriptionBelowChange =
    local.descriptionBelow != null && normalizeString(local.descriptionBelow) !== normalizeString(original.descriptionBelow);

  const hasNewAttachments = local.localAttachments?.length > 0;
  const hasDeletedAttachments = local.deletedOriginalAttachmentIds?.length > 0;

  return hasDescriptionChange || hasDescriptionBelowChange || hasNewAttachments || hasDeletedAttachments;
};
